<template>
  <div class="doctorPage managerPlan Manager flow">
    <div class="compentTable">
      <div class="title">
          现场质控工作流程
      </div>
      <div class="content" v-if="!editType">
        <div class="ql-editor">
          <div v-html="contentHtml"></div>
        </div>
        <!-- <el-input
            v-model="contentHtml"
            class="contentText"
            type="textarea"
            disabled
            size="mini"
        ></el-input> -->
      </div>
      <div v-if="editType">
        <el-form ref="form" :model="appealParameter" class="qcFrom" :inline="true">
          <el-row>
            <el-col :span="24">
              <el-form-item label="标题">
                <el-input v-model="appealParameter.Title" class="name" placeholder="请输入标题" size="mini"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="正文">
                  <quill-editor 
                    v-model="appealParameter.Content"
                    ref="myQuillEditor" 
                    :options="editorOption" 
                    >
                </quill-editor>
                <!-- <el-input
                  v-model="appealParameter.Content"
                  class="name"
                  type="textarea"
                  placeholder="请输入正文"
                  size="mini"
                ></el-input> -->
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="btn">
        <el-button v-if="!editType" type="primary" @click="edit" round>
          编辑
        </el-button>
        <el-button v-if="editType" type="primary" @click="determine" round>
          确定
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "../../../api";
import axios from "@/js/api";
// 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
 
import { quillEditor } from 'vue-quill-editor'
export default {
  components: {
    quillEditor
  },
  data() {
    return {
      editType: false,
      appealParameter: {
        Title: "",
        Content: "",
      },
      contentHtml:'',
      editorOption: {
       modules:{
         toolbar: [
             ['bold', 'italic', 'underline', 'strike'], //加粗，斜体，下划线，删除线
             [{'header': 1}, {'header': 2}], // 标题，键值对的形式；1、2表示字体大小
             [{'list': 'ordered'}, {'list': 'bullet'}], //列表
            //  [{'script': 'sub'}, {'script': 'super'}], // 上下标
            //  [{'indent': '-1'}, {'indent': '+1'}], // 缩进
            //  [{'align': []}], //对齐方式
            //  [{'direction': 'rtl'}], // 文本方向
             [{'color': []}, {'background': []}], // 字体颜色，字体背景颜色
            //  [{'font': []}], //字体
             [{'header': [1, 2, 3, 4, 5, 6, false]}], //几级标题
             ['clean'], //清除字体样式
            ]
         }
      }, //编辑器配置项
    };
  },
  created() {
      this.getworkflowdata()
  },
  methods: {
    getworkflowdata(){
        axios.ajaxGet("get", Api.api.scene.workflowdata).then((res) => {
            this.appealParameter.Title = res.data.Data.Title?res.data.Data.Title:'';
            this.appealParameter.Content = res.data.Data.Title?res.data.Data.Content:'';
            this.appealParameter = res.data.Data
            this.contentHtml = this.appealParameter.Title + '\n' + '\n' + this.appealParameter.Content
        });
    },
    edit() {
      this.editType = true;
    },
    determine(){
       this.editType = false;
       if (this.appealParameter.UniqueId) {
            axios.ajaxPutBody("put", Api.api.scene.workflowEdit,this.appealParameter).then((res) => {
                this.getworkflowdata()
            });
       }else{
            axios.ajaxPost("post", Api.api.scene.workflowAdd,this.appealParameter).then((res) => {
                this.getworkflowdata()
            });
       }


    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/variables.scss";
@import "@/assets/style/mixin.scss";
.title {
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
  line-height: 14px;
  text-align: center;
  font-style: normal;
  margin-bottom: 28px;
}
.content {
  // background: #3d4049;
  @include bg-color(dialogareai);
  @include text-color(fzColori);
  border-radius: 6px;
  padding: 23px 36px;
  box-sizing: border-box;
  height: calc(100vh - 300px);
}
.btn {
  text-align: center;
  margin-top: 40px;
}
::v-deep.el-form--inline .el-form-item__content{
    width: 90%;
}
.el-form--inline .el-form-item{
    width: 100%;
}
::v-deep.doctorPage .el-textarea__inner{
    width: 100%;
    height: 61vh;
}
::v-deep.doctorPage .contentText .el-textarea__inner{
    background-color: #3d4049 !important;
    font-size: 14px;
    color: #fff;
}
</style>
